/* @flow strict */

import * as React from 'react';
import DataTable from 'react-data-table-component';
import ReactTooltip from 'react-tooltip';

type PropsType = {
  sponsors: [],
  handleSelectRow: () => void,
  eventId: number | string
};

const customStyles = {
  headCells: {
    style: {
      fontWeight: 700,
      fontSize: '1rem'
    }
  }
};

let mock = {
  columns: []
};

const EventPageDetailSponsorBody = ({ sponsors, handleSelectRow, eventId }: PropsType): React.Element<'div'> => {
  try {
    mock = require('./tableHeaders/index.js');
  } catch (e) {
    console.warn('File "./tableHeaders/index.js" doesn\'t exist');
  }

  return (
    <div className="panel-body">
      <div style={{ position: 'relative', minHeight: '120px' }}>
        <div style={{ width: '100%', overflowX: 'auto', position: 'relative' }}>
          <ReactTooltip
            place="right"
            type="light"
            effect="solid"
            multiline
            border
            borderColor='#ddd'
            backgroundColor='white'
            className='ReactTooltipCustom'
          />
          <DataTable
            columns={mock.columns(eventId)}
            data={sponsors}
            customStyles={customStyles}
            selectableRows // add for checkbox selection
            Clicked
            onSelectedRowsChange={(selected: any) => {
                handleSelectRow(selected);
              }}
            selectableRowsHighlight
            pagination={!!_.size(sponsors) > 10}
            highlightOnHover
            responsive
            striped
            fixedHeader
            noHeader
            sortIcon={(): React.Element<typeof React.Fragment> => {
              return (
                <>
                  <span className="-sort-desc" />
                  <span className="-sort-asc" />
                </>
              );
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default EventPageDetailSponsorBody;
